import {
  SECTION_ABN,
  SECTION_REVOLUT,
  SECTION_ICS,
  SECTION_SWIBECO,
  SECTION_CREDIT_AGRICOLE,
  SECTION_CREDIT_MUTUEL_EUR,
  SECTION_BUNQ,
  SECTION_ASN,
  SECTION_UBS,
} from './sections';

export const ALL_BANKS = [
  { id: 'ABN', label: 'ABN AMRO', importLabel: 'ABN Import', section: SECTION_ABN },
  { id: 'ASN', label: 'ASN Bank', importLabel: 'ASN Bank Import', section: SECTION_ASN },
  { id: 'BUNQ', label: 'bunq', importLabel: 'bunq Import', section: SECTION_BUNQ },
  { id: 'CREDIT_AGRICOLE', label: 'Crédit Agricole', importLabel: 'Credit Agricole Import', section: SECTION_CREDIT_AGRICOLE },
  { id: 'ICS', label: 'ICS', importLabel: 'ICS Import', section: SECTION_ICS },
  { id: 'SWIBECO', label: 'Swibeco', importLabel: 'Swibeco Import', section: SECTION_SWIBECO },
  { id: 'CREDIT_MUTUEL', label: 'Crédit Mutuel', importLabel: 'Crédit Mutuel Import', section: SECTION_CREDIT_MUTUEL_EUR },
  { id: 'REVOLUT', label: 'Revolut', importLabel: 'Revolut Import', section: SECTION_REVOLUT },
  { id: 'UBS', label: 'UBS', importLabel: 'UBS Import', section: SECTION_UBS },
];

export const BANKS_STORAGE_KEY = 'pelmeshka_enabled_banks';
